import { render, staticRenderFns } from "./ContactSearchWithBrowse.vue?vue&type=template&id=28dc3b9e"
import script from "./ContactSearchWithBrowse.vue?vue&type=script&lang=ts"
export * from "./ContactSearchWithBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports